import React from 'react';
import './LoadingIcon.css';
import {Box} from "@mui/material";

interface LoadingIconProps {
    width?: number | string;
    height?: number | string;
    isLoading?: boolean;
    showOverlay?: boolean;
}
const LoadingIcon: React.FC<LoadingIconProps> = ({ width = 108, height = 108, isLoading, showOverlay = true }) => {
    if (!isLoading) {
        return null;
    }

    const icon = (
        <div className="loading-icon-container">
            <svg
                className="loading-icon-svg"
                width={width}
                height={height}
                viewBox="5300 0 3200 3000"
                xmlns="http://www.w3.org/2000/svg"
            >
                {/* Path 1: The 'I' part */}
                <path
                    d="m5382.7,2274.1 l351.6,-1661.1 511.6,2.3 -351.6,1661.1z"
                    fill="#00df36"/>
                {/* Path 2: The dot of the 'i', which will flash */}
                <path className="dot" d="m5769.1,446.7 l95.6,-446.2h511.6l-95.6,451z" fill="#00df36"/>
                {/* Path 3: The 'D' part, with a faint outline and a stroke-dasharray animation */}
                <path className="faint-path"
                      d="m6617.8,0 l1368.1,2.3c0,0 540.9,-20.3 430.5,554.4 -110.4,574.7 -263.7,1219.3 -263.7,1219.3 0,0 -101.4,500.3 -676.1,500.3 -574.7,0 -1341,-2.3 -1341,-2.3l99.2,-446.3 1214.8,2.3c0,0 173.5,20.3 220.9,-191.6 47.3,-211.9 214.1,-1005.2 214.1,-1005.2 0,0 42.8,-187.1 -128.5,-187.1 -171.3,0 -728,0 -728,0l-254.7,1217.1 -507.1,-4.5z"
                      fill="none" stroke="#00df36" strokeWidth="50"/>
                <path className="draw-path"
                      d="m6617.8,0 l1368.1,2.3c0,0 540.9,-20.3 430.5,554.4 -110.4,574.7 -263.7,1219.3 -263.7,1219.3 0,0 -101.4,500.3 -676.1,500.3 -574.7,0 -1341,-2.3 -1341,-2.3l99.2,-446.3 1214.8,2.3c0,0 173.5,20.3 220.9,-191.6 47.3,-211.9 214.1,-1005.2 214.1,-1005.2 0,0 42.8,-187.1 -128.5,-187.1 -171.3,0 -728,0 -728,0l-254.7,1217.1 -507.1,-4.5z"
                      fill="none" stroke="#00df36" strokeWidth="50"/>
            </svg>
        </div>
    );

    if (showOverlay) {
        return (
            <Box className="loading-overlay">
                {icon}
            </Box>
        );
    }

    return icon;
};

export default LoadingIcon;
